import { render, staticRenderFns } from "./AsnFieldset.vue?vue&type=template&id=1b12c4ba"
import script from "./AsnFieldset.vue?vue&type=script&lang=js"
export * from "./AsnFieldset.vue?vue&type=script&lang=js"
import style0 from "./AsnFieldset.vue?vue&type=style&index=0&id=1b12c4ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports